import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthorizationService } from '../../services/authorization.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private readonly authz = inject(AuthorizationService);

  readonly showPrivacyLink = computed(() => this.authz.isProfessional() || this.authz.isCollaborator());
}
